module.exports = __webpack_public_path__ + "static/img/ec70a38.7e5f394.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Images/ec70a38.jpg
// module id = ygt8
// module chunks = 1